<div *ngIf="message" class="modal confirm-dialog" tabindex="-1" role="dialog" style="display:block!important">
	<div class="modal-dialog custom-alert" role="document">
		<div class="modal-content">
			<div *ngIf="message?.type == 'confirm'" class="modal-body">
				<div class="row">
					<div class="col-md-12">
						<p class="text-center confirm-message">{{message.options.title}}</p>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<p class="confirm-button">
							<a class="btn {{message.options.btn1Class}} pill px-4 mr-2" (click)="message.yesFn()">
								<span class="">{{message.options.btn1Title}}</span>
							</a>
							<a class="btn {{message.options.btn2Class}} pill px-4 mr-2" (click)="message.noFn()">
								<span class="">{{message.options.btn2Title}}</span>
							</a>

							<!-- <a class="mr-2" (click)="message.yesFn()">
								<button class="btn {{message.options.btn1Class}} pill px-4">{{message.options.btn1Title}}</button>
							</a>
							<a (click)="message.noFn()">
								<button class="btn {{message.options.btn2Class}}">{{message.options.btn2Title}}</button>
							</a> -->
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>